
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import NavMenu from '@/common/navmenu.vue';
import Footer from '@/common/footer.vue';
import { orderList, createOrderAgain, orderNum } from '@/services/http';
import { dateTimeFormatter, readCookie, dateFormatter } from '@/tools/tools';

@Component({
  components: {
    Header,
    Footer,
    NavMenu
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    },
    dateFormatter(value: any) {
      return dateFormatter(value);
    }
  }
})
export default class extends Vue {
  ordernumber: any = { received: 0 };

  loading: boolean = false;

  keyword: string = '';

  orderList: any[] = [];

  activeName: string = 'first';

  isNodata: boolean = true;

  pageNo: number = 1;

  pageSize: number = 10;

  currentpage: number = 1

  totalnumber: number = 0;

  private created() {
    this.getOrderNum();
    this.getOrderList();
  }

  private async getOrderNum() {
    const anchor = readCookie('anchor');
    const ordernumber: any = await orderNum({
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    this.ordernumber = ordernumber.data.data;
  }

  // 获取订单列表
  private async getOrderList() {
    const anchor = readCookie('anchor');
    this.loading = true;
    let status: number = 3;
    if (this.activeName === 'first') {
      status = 3;
    } else if (this.activeName === 'second') {
      status = 4;
    }
    const res: any = await orderList({
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      status,
      src: anchor ? (anchor.src ? anchor.src : 2) : 4,
      keyword: this.keyword,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : '',
      companyId: 1
    });
    if (res.data.code === 100) {
      this.orderList = res.data.data.list;
      this.totalnumber = res.data.data.total;
      this.isNodata = this.orderList.length === 0;
    } else {
      this.$message.error('服务器异常!');
    }
    this.loading = false;
  }

  // 评价
  private async comment(details: object) {
    sessionStorage.setItem('commentDetails', JSON.stringify(details));
    (this as any).$router.push({ name: 'Comment' });
  }

  // 再次购买
  private async buyAgain(item: any) {
    const anchor = readCookie('anchor');
    const res: any = await createOrderAgain({
      orderNo: item.orderNo,
      equip: anchor ? anchor.equip : 4,
      version: anchor ? anchor.version : ''
    });
    if (res.data.code === 100) {
      this.$router.push('/card');
    } else {
      this.$message.error(res.data.message);
    }
  }

  handleSizeChange(pageSize: number) {
    this.pageSize = pageSize;
    this.getOrderList();
    window.scrollTo(0, 0);
  }

  handleCurrentChange(pageNo: number) {
    this.pageNo = pageNo;
    this.getOrderList();
    window.scrollTo(0, 0);
  }

  private search() {
    this.pageSize = 10;
    this.pageNo = 1;
    this.getOrderList();
  }
}
